import { Component, Prop, Vue } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { Variant, VariantFilterOptionsModel, VariantFilterValue, FilterType } from "../models/product";
import UniqueVariantFilter from "./UniqueVariantFilter";
import ImageVariantFilter from "./ImageVariantFilter";

@Component({ components: {
    UniqueVariantFilter,
    ImageVariantFilter
}})
export default class SingleVariantFilter extends Vue {

    protected thisSelectedFilterValue: string = "";

    @Prop()
    protected filter!: VariantFilterOptionsModel;

    constructor() {
        super();
    }

    protected created() {
        this.setInitialSelectedFilterValue();
    }

    protected isImageFilter(filterType: number) {
        return filterType === FilterType.Image;
    }

    private setInitialSelectedFilterValue() {
        this.selectedFilterValue =  this.getAttributeValue(this.selectedVariant, this.filter.filterId);
    }

    get variants(): Variant[] {
        return productStore.variants;
    }

    get selectedFilterValue(): string {
        return this.getAttributeValue(this.selectedVariant, this.filter.filterId);
    }

    set selectedFilterValue(value: string) {
        const variants = this.variants.filter(v => this.hasAttribute(v, this.filter.filterId, value));
        if (this.selectedVariant) {
            const variantFound = variants.find(x => x.variantId === this.selectedVariant.variantId);
            if (variantFound) {
                productStore.dispatchVariant(variantFound);
            } else {
                productStore.dispatchVariant(variants[0]);
            }
        } else {
            productStore.dispatchVariant(variants[0]);
        }
    }

    get variantsWithFilterValue(): Variant[] {
        const selectedFilterValue = this.selectedFilterValue;
        const variants = this.variants.filter(v => this.hasAttribute(v, this.filter.filterId, selectedFilterValue));

        if (variants.length === 1) {
           return [];
        } else {
           return variants;
        }
    }

    private hasAttribute(variant: Variant, id: string, value: string): boolean {
        for (const attribute of variant.variantAttributes) {
            if (attribute.attributeId === id) {
                if (attribute.attributeValue === value) {
                    return true;
                }
            }
        }

        return false;
    }

    private getAttributeValue(variant: Variant, filterId: string): string {
        for (const attribute of variant.variantAttributes) {
            if (attribute.attributeId === filterId) {
                return attribute.attributeValue;
            }
        }

        return "";
    }

    get selectedVariant() {
        return productStore.variant;
    }

    get selectedVariantId(): string {
        return this.selectedVariant.variantId;
    }

    set selectedVariantId(value: string) {
        const variant = this.variants.find(x => x.variantId.toString() === value.toString());

        if (variant) {
            productStore.dispatchVariant(variant);
        }
    }
}
